"use strict";

var addConstants = require("../utils").addConstants;

var table = require("./dom-exception-table.json"); // https://heycam.github.io/webidl/#idl-DOMException-error-names
// Precompute some stuff. Mostly unnecessary once we take care of the TODO below.


var namesWithCodes = Object.keys(table).filter(function (name) {
  return "legacyCodeValue" in table[name];
});
var codesToNames = Object.create(null);
var _iteratorNormalCompletion = true;
var _didIteratorError = false;
var _iteratorError = undefined;

try {
  for (var _iterator = namesWithCodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
    var name = _step.value;
    codesToNames[table[name].legacyCodeValue] = name;
  }
} catch (err) {
  _didIteratorError = true;
  _iteratorError = err;
} finally {
  try {
    if (!_iteratorNormalCompletion && _iterator.return != null) {
      _iterator.return();
    }
  } finally {
    if (_didIteratorError) {
      throw _iteratorError;
    }
  }
}

module.exports = DOMException; // TODO: update constructor signature to match WebIDL spec
// See also https://github.com/heycam/webidl/pull/22 which isn't merged as of yet

function DOMException(code, message) {
  var name = codesToNames[code];

  if (message === undefined) {
    message = table[name].description;
  }

  Error.call(this, message);
  Object.defineProperty(this, "name", {
    value: name,
    writable: true,
    configurable: true,
    enumerable: false
  });
  Object.defineProperty(this, "code", {
    value: code,
    writable: true,
    configurable: true,
    enumerable: false
  });

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, DOMException);
  }
}

Object.setPrototypeOf(DOMException, Error);
Object.setPrototypeOf(DOMException.prototype, Error.prototype);
var constants = Object.create(null);
var _iteratorNormalCompletion2 = true;
var _didIteratorError2 = false;
var _iteratorError2 = undefined;

try {
  for (var _iterator2 = namesWithCodes[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
    var _name = _step2.value;
    constants[table[_name].legacyCodeName] = table[_name].legacyCodeValue;
  }
} catch (err) {
  _didIteratorError2 = true;
  _iteratorError2 = err;
} finally {
  try {
    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
      _iterator2.return();
    }
  } finally {
    if (_didIteratorError2) {
      throw _iteratorError2;
    }
  }
}

addConstants(DOMException, constants);